// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"101":"9b8e47e2","190":"a3514a8d","557":"ef9d461c","618":"5b027848","651":"a13b4939","806":"0a247fba","814":"7f0ed093","973":"fd428418"}[chunkId] + ".js";
};